import { IconButton } from '@mui/material';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Tooltip from '@mui/material/Tooltip';
import { BoxEvents, BoxSettings, BoxTools, DrawerStyle, IconButtonStyle } from './style';
import { NavLink } from 'react-router-dom';
import { routesProfile } from '../../../consts';
import { NotificationsNoneRoundedIcon } from '../../../icons/NotificationsNoneRoundedIcon';
import { IconAddProject } from '../../../icons/IconAddProject';
import { IconAddPersonalGrowthTools } from '../../../icons/IconAddPersonalGrowthTools';
import { IconProfile } from '../../../icons/IconProfile';
import { IconSettings } from '../../../icons/IconSettings';
import { IconAddSocialOrder } from '../../../icons/IconAddSocialOrder';
import { IconAddTeams } from '../../../icons/IconAddTeams';
import { StyledBadge } from '../../ui-kit';
import { COLORS } from '../../../styles/variables';
import { profileApi } from '../../../api/profile';
import { notificationsApi } from '../../../api/notifications';
import { RecommendationsNavBadge } from '../RecommendationsNavBadge';
import { RecommendationRoundedIcon } from '../../../icons/RecommendationRoundedIcon';

export const Sidebar = () => {
  const { data: me } = profileApi.useGetProfileQuery()
  const { data: unreadData } = notificationsApi.useGetNotificationsUnreadCountQuery(undefined, {
    refetchOnFocus: true,
    refetchOnReconnect: true,
  })
  const unreadCount = unreadData?.unread_count ?? 0

  return (
    <Drawer
      variant="permanent"
      sx={DrawerStyle}
    >
      <Box sx={BoxEvents}>
        <Tooltip title="События" placement="right" arrow>
          <IconButton component={NavLink} to={`../${routesProfile.ROOT.path}`} sx={IconButtonStyle}>
            <StyledBadge
              overlap="circular"
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              variant="dot"
              invisible={unreadCount === 0}
              colorBadge={COLORS.CADMIUM_RED}
              size={8}
            >
              <NotificationsNoneRoundedIcon fontSize="medium" />
            </StyledBadge>
          </IconButton>
        </Tooltip>
        <Tooltip title="Рекомендации" placement="right" arrow>
          <IconButton component={NavLink} to={`../${routesProfile.RECOMMENDATIONS.path}`} sx={IconButtonStyle}>
            <RecommendationsNavBadge>
              <RecommendationRoundedIcon fontSize="medium" />
            </RecommendationsNavBadge>
          </IconButton>
        </Tooltip>
      </Box>

      <Box sx={BoxTools}>
        <Tooltip title="Ваша страница" placement="right" arrow>
          <IconButton component={NavLink} to={`../${routesProfile.USERS.path}/${me?.slug}`} sx={IconButtonStyle}>
            <IconProfile />
          </IconButton>
        </Tooltip>
        <Tooltip title="Новый проект" placement="right" arrow>
          <IconButton component={NavLink} to={`../${routesProfile.PROJECTS.path}/create`} sx={IconButtonStyle}>
            <IconAddProject />
          </IconButton>
        </Tooltip>
        <Tooltip title="Новый социальный заказ" placement="right" arrow>
          <IconButton component={NavLink} to={`../${routesProfile.SOCIALORDERS.path}/create`} sx={IconButtonStyle}>
            <IconAddSocialOrder />
          </IconButton>
        </Tooltip>
        <Tooltip title="Новый инструмент роста" placement="right" arrow>
          <IconButton component={NavLink} to={`../${routesProfile.GROWTHTOOLS.path}/create`} sx={IconButtonStyle}>
            <IconAddPersonalGrowthTools />
          </IconButton>
        </Tooltip>
        <Tooltip title="Новая команды" placement="right" arrow>
          <IconButton component={NavLink} to={`../${routesProfile.TEAMS.path}/create`} sx={IconButtonStyle}>
            <IconAddTeams />
          </IconButton>
        </Tooltip>
      </Box>

      <Box sx={BoxSettings}>
        <Tooltip title="Настройки" placement="right" arrow>
          <IconButton component={NavLink} to={`../${routesProfile.SETTINGS.path}`} sx={IconButtonStyle}>
            <IconSettings />
          </IconButton>
        </Tooltip>
      </Box>
    </Drawer>
  );
};
